import React from "react"

interface BrandMarkProps {
  size?: number
  className?: string
}

// Tùy biến KHCN: biểu tượng bóng đèn (ý tưởng) trên nền xanh, bóng vàng phát sáng — theo bản thiết kế.
// Vẽ bằng SVG để sắc nét ở mọi kích thước và đổi màu theo token.
export const BrandMark = ({ size = 40, className }: BrandMarkProps) => (
  <svg viewBox="0 0 48 48" width={size} height={size} className={`kh-brand ${className || ""}`} aria-hidden="true" focusable="false">
    <defs>
      <linearGradient id="khBrandBg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#2f8bff" />
        <stop offset="1" stopColor="#0e4cb5" />
      </linearGradient>
      <linearGradient id="khBrandBulb" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#ffe08a" />
        <stop offset="1" stopColor="#f2b900" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="44" height="44" rx="14" fill="url(#khBrandBg)" />
    {/* tia sáng */}
    <g className="kh-brand__rays" stroke="#ffe08a" strokeWidth="2" strokeLinecap="round" opacity="0.95">
      <line x1="24" y1="5.5" x2="24" y2="9" />
      <line x1="12.6" y1="10.2" x2="15.1" y2="12.7" />
      <line x1="35.4" y1="10.2" x2="32.9" y2="12.7" />
      <line x1="9" y1="21" x2="12.5" y2="21" />
      <line x1="39" y1="21" x2="35.5" y2="21" />
    </g>
    {/* bầu đèn */}
    <path
      className="kh-brand__glass"
      d="M24 11.5a9.5 9.5 0 0 0-5.6 17.2c1.1.8 1.8 2 2 3.3h7.2c.2-1.3.9-2.5 2-3.3A9.5 9.5 0 0 0 24 11.5z"
      fill="url(#khBrandBulb)"
    />
    {/* dây tóc */}
    <path d="M21 25.5l1.6-3 1.4 3 1.4-3 1.6 3" fill="none" stroke="#0e4cb5" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    {/* đuôi đèn */}
    <rect x="20" y="34" width="8" height="2.6" rx="1.3" fill="#ffffff" opacity="0.95" />
    <rect x="21" y="38" width="6" height="2.6" rx="1.3" fill="#ffffff" opacity="0.8" />
  </svg>
)
